/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Cli_PcInputs */

const en_pc_cmp_r_cli_pc = /** @type {(inputs: Pc_Cmp_R_Cli_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pdfcraft-cli included`)
};

const zh_pc_cmp_r_cli_pc = /** @type {(inputs: Pc_Cmp_R_Cli_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自带 pdfcraft-cli`)
};

/**
* | output |
* | --- |
* | "pdfcraft-cli included" |
*
* @param {Pc_Cmp_R_Cli_PcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_cli_pc = /** @type {((inputs?: Pc_Cmp_R_Cli_PcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Cli_PcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_cli_pc(inputs)
	return zh_pc_cmp_r_cli_pc(inputs)
});
export { pc_cmp_r_cli_pc as "pc.cmp.r.cli.pc" }